import { defineStore } from 'pinia';

import { sdk } from '@/sdk';

interface BusinessUnit {
  id: string;
  name: string;
}

interface State {
  fetching: boolean;
  units: BusinessUnit[];
}

export const useBusinessUnitsStore = defineStore('businessUnits', {
  state: (): State => ({ units: [], fetching: false }),

  actions: {
    async fetch() {
      if (this.fetching) return;
      this.fetching = true;
      try {
        const result = await sdk.businessUnits.list();
        this.$patch({ units: result.data ?? [] });
      } catch (e) {
        console.error('Failed to fetch business units', e);
      } finally {
        this.fetching = false;
      }
    },
  },

  getters: {
    getNameById: (state) => (id: string) => state.units.find((u) => u.id === id)?.name ?? null,
  },
});
